import { E_SSORestrictType } from 'library-components/apis/login/login.type';
import { getAlertDataByCode } from 'library-components/config/alertMsg';
import _ from 'lodash';
export function getTenantDisabledTooltip(item, lang) {
    const getAlertDataByCodeParams = {
        code: null,
        lang,
        loginUrl: item?.login_url,
    };
    const msgAry = [];
    if (_.isBoolean(item.account_status_active) && !item.account_status_active) {
        getAlertDataByCodeParams.code = 30177;
        msgAry.push(getAlertDataByCode(getAlertDataByCodeParams).msg);
    }
    if (item.domain_restrict) {
        getAlertDataByCodeParams.code = 30145;
        msgAry.push(getAlertDataByCode(getAlertDataByCodeParams).msg);
    }
    if (item.ip_restrict) {
        getAlertDataByCodeParams.code = 30108;
        msgAry.push(getAlertDataByCode(getAlertDataByCodeParams).msg);
    }
    if (item.sso_restrict) {
        if (item.sso_restrict_type === E_SSORestrictType.DINGTLK) {
            getAlertDataByCodeParams.code = 30173;
        }
        else if (item.sso_restrict_type === E_SSORestrictType.FEISHU) {
            getAlertDataByCodeParams.code = 30175;
        }
        else if (item.sso_restrict_type === E_SSORestrictType.WECHAT_ENTERPRISE) {
            getAlertDataByCodeParams.code = 30174;
        }
        else if (item.sso_restrict_type === E_SSORestrictType.JWT) {
            getAlertDataByCodeParams.code = 30176;
        }
        else {
            getAlertDataByCodeParams.code = 30142;
        }
        msgAry.push(getAlertDataByCode(getAlertDataByCodeParams).msg);
    }
    return msgAry.join('<div style="margin-bottom: 8px"></div>');
}
